module.exports = __webpack_public_path__ + "img/lv5_1_1.33d10e96.png";